module.exports = __webpack_public_path__ + "9b1b76854f5b9cd0e51cde5c87e48fd4.png";